module.exports = __webpack_public_path__ + "static/man-g-b6fd42c159872717d79ab6cc99100c6b.jpg";